export default __webpack_public_path__ + "static/media/ET.fd665047.svg";